import { router } from '@inertiajs/vue3'
import { defineShortcuts } from '@nuxt/ui/composables'
import { createSharedComposable } from '@vueuse/core'

import {
  adminCustomersPath,
  adminProductsPath,
  adminRootPath,
  adminSettingsProfilePath,
  adminSettingsSessionsPath,
} from '@/routes'

function _useDashboard() {
  defineShortcuts({
    'g-h': () => router.visit(adminRootPath()),
    'g-p': () => router.visit(adminProductsPath()),
    'g-c': () => router.visit(adminCustomersPath()),
    'g-s': () => router.visit(adminSettingsProfilePath()),
    'g-a': () => router.visit(adminSettingsSessionsPath()),
  })
}

export const useDashboard = createSharedComposable(_useDashboard)
